import apiClient from '../utils/apiClient';

/**
 * Get all team roles for the company
 */
export const getTeamRoles = async () => {
  const response = await apiClient.get('/api/team-roles');
  return response.data;
};

/**
 * Get a specific team role by ID
 */
export const getTeamRole = async (roleId) => {
  const response = await apiClient.get(`/api/team-roles/${roleId}`);
  return response.data;
};

/**
 * Create a new team role
 */
export const createTeamRole = async (roleData) => {
  const response = await apiClient.post('/api/team-roles', roleData);
  return response.data;
};

/**
 * Update an existing team role
 */
export const updateTeamRole = async (roleId, roleData) => {
  const response = await apiClient.put(`/api/team-roles/${roleId}`, roleData);
  return response.data;
};

/**
 * Delete a team role
 */
export const deleteTeamRole = async (roleId) => {
  const response = await apiClient.delete(`/api/team-roles/${roleId}`);
  return response.data;
};
